/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".alert[_ngcontent-%COMP%]{font-size:.75rem;margin-bottom:10px}.alert.account-created[_ngcontent-%COMP%]{font-size:.75rem;margin-bottom:10px;color:#fff;border:none;font-weight:600}.special-link[_ngcontent-%COMP%]{color:#11526a;font-size:inherit}.special-link[_ngcontent-%COMP%]:hover{color:#11526a}"];
export { styles as styles };
